export default "__VITE_ASSET__B5xR7BG8__"